export const SharedStyles = {
  flyouts: {
    tabClasses: ['flex', 'items-center', 'gap-1'],
  },
};
